import React from 'react';
import FormLayout from '../FormLayout';
import FormLayoutField from '../FormLayoutField';
import { Field } from 'redux-form';

/** Class representing a hidden form field (HTML type=hidden). */
class HiddenField extends FormLayoutField {

    constructor(properties) {
        super({
            ...(HiddenField.getDefaultOptions()),
            ...properties,
        });

        this.type = FormLayout.HIDDEN;
    }

    static getDefaultOptions() {
        const properties = super.getDefaultOptions();
        const existing = properties.content && typeof properties.content === 'object' ? properties.content : {};
        properties.content = { ...existing, default: existing.default ?? '' };
        return properties;
    }

    getHandledOptions() {
        return [
            FormLayout.OPTION_NAME,
            FormLayout.OPTION_WIDTH,
            FormLayout.OPTION_DEFAULT_VALUE,
        ];
    }

    getFormInitialValue() {
        const raw = this.content?.default;
        if (raw === undefined || raw === null) {
            return undefined;
        }
        const value = String(raw);
        return value === '' ? undefined : value;
    }

    getLabel(_props) {
        return null;
    }

    getPreview(_props) {
        const defaultValue = this.content?.default != null && this.content.default !== ''
            ? String(this.content.default)
            : null;
        return (
            <div className="field-wrapper form-group form-field-hidden-preview text-muted small">
                <i className="fa fa-eye-slash" aria-hidden="true" />
                {' '}
                <span className="font-monospace">{this.name || '—'}</span>
                {defaultValue != null && (
                    <span className="ml-1">
                        = <span className="font-monospace">{defaultValue}</span>
                    </span>
                )}
            </div>
        );
    }

    getInput(props) {
        return (
            <Field
                component="input"
                type="hidden"
                name={this.reduxFieldName(props)}
            />
        );
    }

    getIcon() {
        return 'eye-slash';
    }
}

export default HiddenField;
